// product-sticky-bar.js
(function () {
  if (typeof document === 'undefined' || typeof window === 'undefined') return;

  const stickyBar = document.querySelector('[data-product-sticky-bar]');
  if (!stickyBar) return;

  const footer = document.querySelector('[data-site-footer]');
  const footerStickyClass = 'product-sticky-visible';

  const setStickyState = (shouldShow) => {
    stickyBar.dataset.visible = shouldShow ? 'true' : 'false';
    stickyBar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    if (footer) {
      footer.classList.toggle(footerStickyClass, shouldShow);
    }
  };

  const getInnerSelect = (host) => {
    return host?.querySelector('select');
  };

  const getInnerSelectValue = (host) => {
    const inner = getInnerSelect(host);
    return inner ? inner.value : '';
  };

  const setInnerSelectValue = (host, value, { dispatch = true } = {}) => {
    const inner = getInnerSelect(host);
    if (!inner) return;
    inner.value = value;
    if (dispatch) {
      inner.dispatchEvent(new Event('change', { bubbles: true }));
    }
  };

  const registerQuantityHandler = (element, handler) => {
    if (!element) return;
    const listeners = (el) => {
      el.addEventListener('input', handler);
      el.addEventListener('change', handler);
      el.addEventListener('ck-change', handler);
      el.addEventListener('quantity-change', handler);
    };
    listeners(element);
    const nestedInput = element.querySelector('input');
    if (nestedInput) {
      listeners(nestedInput);
    }
  };

  const setQuantityValue = (element, value) => {
    if (!element) return;
    element.value = value;
    const nestedInput = element.querySelector('input');
    if (nestedInput) {
      nestedInput.value = value;
    }
  };

  const getQuantityValueFromElement = (el) => {
    if (!el) return '';
    const innerInput = el.querySelector('input');
    if (innerInput && innerInput.value != null) return innerInput.value;
    return el.value ?? el.getAttribute('value') ?? '';
  };

  const log = (...args) => console.info('[product-sticky-bar]', ...args);
  let isUpdatingStickyFromMain = false;

  const syncQuantity = (source, target, runInitially = false, label = 'sync') => {
    if (!source || !target) return;

    let syncing = false;

    const handler = () => {
      if (syncing) return;
      syncing = true;
      const newValue = getQuantityValueFromElement(source);
      setQuantityValue(target, newValue);
      target.dispatchEvent(new Event('input', { bubbles: true }));
      target.dispatchEvent(new Event('change', { bubbles: true }));
      const innerTargetInput = target.querySelector('input');
      if (innerTargetInput) {
        innerTargetInput.dispatchEvent(new Event('input', { bubbles: true }));
        innerTargetInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      log(`${label} →`, newValue);
      syncing = false;
    };

    registerQuantityHandler(source, handler);
    if (runInitially) {
      handler();
    }
  };

  const initStickyBindings = () => {
    const mainAddButton = document.querySelector(
      '[data-add-to-cart-button]:not([data-sticky-add-to-cart-button])'
    );
    if (!mainAddButton) return false;

    const productForm = mainAddButton.closest('form[action*="/cart/add"]');
    if (!productForm) return false;

    const stickyAddButton = stickyBar.querySelector('[data-sticky-add-to-cart-button]');
    if (stickyAddButton) {
      stickyAddButton.addEventListener('click', (event) => {
        event.preventDefault();
        mainAddButton.click();
      });
    }

    const mainQuantity = productForm.querySelector(
      'ck-quantity-input:not([data-sticky-quantity-input])'
    );
    const stickyQuantity = stickyBar.querySelector('[data-sticky-quantity-input]');

    if (mainQuantity && stickyQuantity) {
      syncQuantity(mainQuantity, stickyQuantity, true, 'main→sticky');
      syncQuantity(stickyQuantity, mainQuantity, false, 'sticky→main');
    }

    const stickyVariantSelect = stickyBar.querySelector('[data-sticky-variant-select]');
    const mainVariantSelect = productForm.querySelector('[data-product-variant-select]');
    const productId = mainVariantSelect?.dataset?.productVariantSelect;
    const selectVariantIfAvailable =
      typeof window !== 'undefined' && typeof window.selectVariantForProduct === 'function'
        ? window.selectVariantForProduct
        : null;

    if (stickyVariantSelect && mainVariantSelect) {
      const handleStickyVariantChange = () => {
        if (isUpdatingStickyFromMain) {
          return;
        }

        const newValue = getInnerSelectValue(stickyVariantSelect);
        log('sticky variant change ->', newValue);
        if (selectVariantIfAvailable && productId) {
          selectVariantIfAvailable(productId, newValue);
          return;
        }

        mainVariantSelect.value = newValue;
        mainVariantSelect.dispatchEvent(new Event('change', { bubbles: true }));
      };

      const handleMainVariantChange = () => {
        const currentValue = mainVariantSelect.value;
        log('main variant change → sticky', currentValue);
        isUpdatingStickyFromMain = true;
        setInnerSelectValue(stickyVariantSelect, currentValue, { dispatch: false });
        isUpdatingStickyFromMain = false;
      };

      stickyVariantSelect.addEventListener('change', handleStickyVariantChange);
      mainVariantSelect.addEventListener('change', handleMainVariantChange);
      handleMainVariantChange();
    }

    setStickyState(false);

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (!entry) return;
        setStickyState(!entry.isIntersecting);
      },
      {
        threshold: 0.05,
      }
    );

    observer.observe(mainAddButton);
    return true;
  };

  const pollForForm = () => {
    if (initStickyBindings()) return;
    requestAnimationFrame(pollForForm);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pollForForm);
  } else {
    pollForForm();
  }
})();
